import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import {
  EditNewPinScreen,
  ForgetPinScreen,
  LoginScreen,
  RegisterScreen,
  VerificationScreen,
} from "screens"
import { colors } from "colors"
import { translate } from "i18n"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"
import { WebViewScreen } from "screens/Authentication/WebView"
import { ExistingScreen } from "screens/Authentication/Existing"
import { useColor } from "app/theme/getThemes"

export type AuthParamList = {
  login: undefined
  verification: undefined
  register: undefined
  forgetPin: undefined
  editNewPin: undefined
  existing: undefined
  webView: undefined
}
const Stack = createStackNavigator<AuthParamList>()

export const AuthStack = () => {
  const { companyTheme } = useColor()

  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        headerStyle: {
          backgroundColor: companyTheme.first,
        },
        headerBackImage: () => <MaterialIcons name="chevron-left" color="white" size={42} />,
        headerBackTitleVisible: false,
        headerTitleAlign: "center",
        headerTitleStyle: {
          color: "white",
        },
        headerTintColor: "white",
        cardStyle: { flex: 1 },
      }}
    >
      <Stack.Screen
        name="login"
        component={LoginScreen}
        options={{
          headerTitle: translate("loginScreen.title"),
        }}
      />
      <Stack.Screen
        name="verification"
        component={VerificationScreen}
        options={{ title: translate("verificationScreen.title") }}
      />
      <Stack.Screen
        name="register"
        component={RegisterScreen}
        options={{ title: translate("registerScreen.title") }}
      />
      <Stack.Screen
        name="existing"
        component={ExistingScreen}
        options={{ title: translate("existingScreen.title") }}
      />
      <Stack.Screen
        name="forgetPin"
        component={ForgetPinScreen}
        options={{ title: translate("forgetPinScreen.title") }}
      />
      <Stack.Screen
        name="editNewPin"
        component={EditNewPinScreen}
        options={{ title: translate("editNewPinScreen.title") }}
      />
      <Stack.Screen name="webView" component={WebViewScreen} options={{ title: "WebView" }} />
    </Stack.Navigator>
  )
}
